import axios from 'axios';
import { createSignedGetRequest } from 'utils/createSignedRequestsHelpers';
import { ADMIN_AI_LOCAL_API_REQUESTS } from './constants';

/**
 * GET /legacy_admin/ai/usage/months — the months that have any usage rows, newest
 * first, as `{ generatedAt, months: [{ yearMonth, rows }] }`; system admin
 * only.
 */
export const getAdminAiUsageMonths = async () => {
  const signedRequest = await createSignedGetRequest({
    apiPath: 'legacy_admin/ai/usage/months',
    isLocalApiRequest: ADMIN_AI_LOCAL_API_REQUESTS,
  });
  const response = await axios(signedRequest);
  return response.data;
};
